# A mixin to hyrate a component with a Craft @product with the related
# Grassdoor variant options
export default

	computed:

		# Simple helper for whether this product has Grassdoor products
		hasGrassdoorVariants: -> @grassdoorVariants.length > 0

		# Get a list of all the grassdoor product objectes (which are like
		# variants) for *this* product
		grassdoorProducts: ->
			@$nonEmpty (@product.grassdoorSlugs || []).map ({ slug }) =>
				@lookupGrassdoorProduct slug

		# Make a Shopify-like variants array given this product
		grassdoorVariants: ->
			@grassdoorProducts.map (grassdoorProduct) =>
				@makeVariantFromGrassdoorProduct @product, grassdoorProduct

		# Make a Shopify-like product options array from the variants
		grassdoorVariantOptions: -> @makeVariantOptions @grassdoorVariants

		# Merge grassdoor data into the @product and return a new object
		productWithGrassdoorVariants: ->
			return @product unless @hasGrassdoorVariants
			{
				...@product
				isPurchaseableViaGrassdoorCart: true
				options: @grassdoorVariantOptions
				variants: @grassdoorVariants
			}

	methods:

		# Map into a format that is similar to Shopify's variants. This makes
		# the variant title from the weight, assuming that's the only thing
		# that will vary beween variants. Also, I'm not using the Grassdoor
		# image.  If we needed too, though, I could route it through Imagix to
		# crop it.
		# https://app.asana.com/0/0/1204302083740561/f
		makeVariantFromGrassdoorProduct: (craftProduct, grassdoorProduct) ->
			id: grassdoorProduct.mappingId
			sku: grassdoorProduct.mappingId
			title: grassdoorProduct.name
			image: null # See comment above
			selectedOptions: do ->
				unless grassdoorProduct.weight then [] else [
					name: 'Size',
					value: "#{grassdoorProduct.weight}#{grassdoorProduct.unit}"
				]
			price: amount: grassdoorProduct.salePrice
			compareAtPrice: amount: grassdoorProduct.listPrice
			available: !grassdoorProduct.isSoldOut
			sellingPlanAllocations: null
			url: "#{process.env.URL}/products/#{craftProduct.slug}/#{grassdoorProduct.mappingId}"

		# Look up a product's Grassdoor data by slug
		lookupGrassdoorProduct: (grassdoorSlug) ->
			return unless grassdoorSlug
			@$store.state.cart.purchaseableProducts.find (grassdoorProduct) ->
				grassdoorProduct.slug == grassdoorSlug

		# Take a Shopify-like variants selectedOptions array and make a Shopify-like
		# array of all of the options.
		# https://shopify.dev/docs/api/storefront/2023-01/objects/ProductOption
		makeVariantOptions: (variants = []) ->
			variants.reduce (options, variant) ->
				return options unless variant.selectedOptions?.length
				for selectedOption in variant.selectedOptions
					if option = options.find ({ name }) -> name == selectedOption.name
					then option.values.push selectedOption.value
					else options.push
						name: selectedOption.name
						values: [ selectedOption.value ]
				return options
			, []
